import { RegularButton, Modal } from 'fronton-react'
import { FC } from "react";
import './modalClasses.scss'

export interface BigGapModalProps {
    open: boolean,
    onClose: () => void,
    onSave: () => void,
}

export const BigGapModal: FC<BigGapModalProps> = ({open, onClose, onSave}) => {
    return (
        <Modal
        size="s"
        show={open}
        className="add-calendar-modal"
        closeButton={false}
        onClose={onClose}
        overlayType="medium"
    >
        <div className="modal-content">
            <div className="modal-content-body">
                Для некоторых магазинов/регионов срок между последним и первым заказом
                больше 5 недель. Даты введены корректно?
            </div>
            <div className="modal-content-actions">
                <RegularButton
                    key="submit"
                    size="s"
                    variant="primary"
                    className="modal-content-btn"
                    onClick={() => {
                        onSave()
                        onClose()
                    }}
                >
                    Да
                </RegularButton>
                <RegularButton
                    key=""
                    size="s"
                    variant="primary"
                    className="modal-content-btn"
                    onClick={onClose}
                >
                    Нет
                </RegularButton>
            </div>
        </div>
    </Modal>

    )
}